import { apiRequest } from "./client";
import type {
  MeHistory,
  MeLoginResponse,
  MeSession,
  MeToday,
  MantraLedger,
  Notice,
  NoticeInput,
} from "../types";

const PREFIX = "/biometric/me";

function authParams(session: MeSession) {
  return {
    person_id: String(session.person_id),
    phone: session.phone,
    device_pin: session.device_pin,
  };
}

function authBody(session: MeSession, extra?: object) {
  return {
    person_id: session.person_id,
    phone: session.phone,
    device_pin: session.device_pin,
    ...extra,
  };
}

export const meApi = {
  login(phone: string, device_pin: string) {
    return apiRequest<MeLoginResponse>(`${PREFIX}/login`, {
      method: "POST",
      body: { phone, device_pin },
    });
  },

  getToday(session: MeSession) {
    return apiRequest<MeToday>(`${PREFIX}/today`, {
      params: authParams(session),
    });
  },

  getHistory(session: MeSession, month: string) {
    return apiRequest<MeHistory>(`${PREFIX}/history`, {
      params: { ...authParams(session), month },
    });
  },

  submitNotice(session: MeSession, data: NoticeInput) {
    return apiRequest<Notice>(`${PREFIX}/notices`, {
      method: "POST",
      body: authBody(session, data),
    });
  },

  listMyNotices(session: MeSession) {
    return apiRequest<Notice[]>(`${PREFIX}/notices`, {
      params: authParams(session),
    });
  },

  getMantras(session: MeSession) {
    return apiRequest<MantraLedger>(`${PREFIX}/mantras`, {
      params: authParams(session),
    });
  },

  submitMantras(session: MeSession, dates: string[], notes?: string) {
    return apiRequest<MantraLedger>(`${PREFIX}/mantras`, {
      method: "POST",
      body: authBody(session, { dates, notes }),
    });
  },
};
